import { makeStyles, createStyles } from '@material-ui/core'

export const useProjectCardStyles = makeStyles((theme) =>
  createStyles({
    position: {},

    root: {
      position: 'relative',
      width: '100%',
      height: 'auto',
      overflow: 'visible',
      marginBottom: theme.spacing(5),
      boxShadow: '0px 4px 25px rgba(0, 0, 0, 0.1)',
      borderRadius: '4px 4px 9px 9px',

      '&:hover $menu': {
        visibility: 'visible',
        transition: theme.transitions.create('visibility', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.complex
        })
      }
    },

    fullNameDiv: {
      marginTop: 2,
      color: 'black',
      overflow: 'hidden',
      lineHeight: '40px',
      marginBottom: '10px'
    },

    info: {
      height: '40px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',

      [theme.breakpoints.down(1440)]: {
        flexDirection: 'column',
        alignItems: 'flex-start'
      }
    },

    content: {
      padding: theme.spacing(1)
    },

    name: {
      maxWidth: 156,
      cursor: 'pointer',
      marginLeft: '5px',

      ['@media (max-width: 350px)']: {
        maxWidth: 50
      }
    },

    iconName: {
      position: 'relative',
      marginRight: 10,
      marginBottom: 5,

      [theme.breakpoints.down('xs')]: {
        top: 10,
        left: 0
      }
    },

    fullName: {
      display: 'flex',
      alignItems: 'center',
      '-webkit-line-clamp': 1,
      '-webkit-box-orient': 'vertical',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      marginLeft: 10,
      [theme.breakpoints.down(1440)]: {
        marginBottom: theme.spacing(1)
      }
    },

    fullNameText: {
      display: 'flex',
      flexDirection: 'column'
    },

    nameBlock: {
      height: 45,
      display: '-webkit-box',
      '-webkit-line-clamp': 2,
      '-webkit-box-orient': 'vertical',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      marginBottom: theme.spacing(1),
      fontSize: 16,
      fontWeight: 500,
      zIndex: 500,
      transition: '0.3s',
      '&:hover': {
        textDecoration: 'underline'
      }
    },

    img: {
      objectFit: 'cover',
      width: '100%',
      display: 'block',
      minHeight: 200,
      height: 211,
      zIndex: -1,
      marginBottom: theme.spacing(2)
    },

    iconWrap: {
      display: 'flex',
      alignItems: 'center'
    },

    avatarUrl: {
      marginRight: 10,
      height: '32px',
      width: '32px',
      borderRadius: '50%'
    },

    actions: {
      alignItems: 'center',

      [theme.breakpoints.down(1440)]: {
        paddingLeft: 0
      }
    },

    cost: {
      fontSize: 16,
      fontWeight: 600,
      color: 'rgba(46, 134, 189, 1)'
    },

    menu: {
      position: 'absolute',
      right: 8,
      top: 8,
      width: '35px',
      height: '35px',
      backgroundSize: '40px 40px',
      backgroundColor: '#fff',
      borderBottomLeftRadius: '4px',
      display: 'flex',
      justifyContent: 'center'
    },

    dateBlock: {
      display: 'flex'
    },

    buttonPosition: {
      display: 'flex',
      justifyContent: 'center'
    },

    button: {
      marginTop: 15,
      padding: '10px 33px',
      fontSize: 14,
      fontWeight: 500,
      borderRadius: 9,
      textTransform: 'none'
    },

    hoverContent: {
      opacity: 0,
      position: 'absolute',
      bottom: '0px',
      left: 0,
      padding: '8px 8px 20px 8px',
      width: '100%',
      zIndex: 100,
      backgroundColor: '#fff',
      borderRadius: '0 0 9px 9px',
      transition: '.3s'
    },

    hoverContentVisible: {
      opacity: 1,
      bottom: '-140px',

      [theme.breakpoints.down(1440)]: {
        bottom: '-150px'
      }
    }
  })
)
